import React, { useEffect, useState, useRef } from "react";
import { EndPoints } from "../../Helpers/Constants/EndPoints";
import Loader from "../Common/Loader";
import API from "../../Helpers/Constants/EndPoints/Api";
import Axios from "../../Helpers/Universal/Axios/Axios";
import { CreatedAt } from "../../Helpers/Universal/Function/common";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Country, State, City } from "country-state-city";
import CustomSelect from "../Forms/CustomSelect";
import { SuperAdminSchema } from "../../Helpers/Constants/Schemas";
import { SuperAdminFields } from "../../Helpers/Constants/InitialValues";
import { CREATE, UPDATE } from "../../Helpers/Constants/Default";
import { LIMIT1, OFFSET } from "../../Helpers/Constants/Default";
import Switch from "react-switch";

const SubAdmin = () => {
  const { state: subAdminId } = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [visible, setVisible] = useState({ loader: false });
  const [permissions, setPermissions] = useState([]);
  const [stateLabel, setStateLabel] = useState("");
  const [statesCode, setStatesCode] = useState("");
  const [manager, setManageList] = useState([]);
  const [statesAndNewUTs, setStatesAndNewUTs] = useState([]);
  const [newcityOptions, setNewCityOptions] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [statesAndUTs, setStatesAndUTs] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [accountType, setAccountType] = useState(null);

  const stateRef = useRef({ test: "hh" });
  const cityRef = useRef({ test: "hh" });
  const [filter, setFilter] = useState({
    limit: LIMIT1,
    offset: OFFSET,
  });

  const superpermission = [
    {
      field: "agents",
      name: "Agents",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "supervisors",
      name: "Supervisors",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "managers",
      name: "Managers",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "subAdmins",
      name: "Area Head",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "admins",
      name: "Regional Head",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "superAdmins",
      name: "Root User",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "notify",
      name: "Notification",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "config",
      name: "Config",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "superLogout",
      name: "Super Logout",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
    {
      field: "cms",
      name: "CMS",
      all: false,
      view: false,
      add: false,
      edit: false,
      delete: false,
    },
  ];

  const getData = async () => {
    try {
      setVisible({ loader: true });
      const { status, data } = await Axios.get(
        API.SUB_ADMIN.DETAILS + "/" + subAdminId
      );
      console.log("API Response:", data);
      
      if (status) {
        setData(data);
        setPermissions(data.roleId?.permissions || superpermission);
        setIsBlocked(data.isBlocked || false);

        // Set additional data for form fields
        if (data.address) {
          setStateLabel(data.address.state);
          setStatesCode(data.address.stateCode);
        }
        if (data.parentId) {
          setSelectedManager(data.parentId);
        }
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible({ loader: false });
    }
  };

  const getStates = async () => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));
      const { status, data } = await Axios.get(API.LOCATION.STATES);
      if (status) {
        setStatesAndNewUTs(data || []);
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  const getCities = async (stateCode) => {
    if (!stateCode) {
      console.log("State code is required to fetch cities.");
      return;
    }

    try {
      setVisible((prev) => ({ ...prev, loader: true }));
      const { status, data } = await Axios.get(
        `${API.LOCATION.CITY}?stateCode=${stateCode}`
      );
      if (status) {
        setNewCityOptions(data || []);
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  const getManagerData = async () => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));
      const { status, data } = await Axios.get(API.SUPERADMIN.LISTING, {
        limit: filter.limit,
        offset: filter.offset,
      });
      if (status === true) {
        setManagers(data.data || []);
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  const getDataSure = async () => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));

      const { status, data } = await Axios.get(API.ADMIN.PARENT, {
      });
      console.log(data.managers)
      console.log(data)
      console.log(status)
      if (status === true) {
        setAccountType(data.accountType);
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
    }
  };

  const handleManagerList = (value) => {
    const groupedByState = value.reduce((acc, employee) => {
      const state = employee.address.state;
      if (!acc[state]) {
        acc[state] = [];
      }
      acc[state].push(employee);
      return acc;
    }, {});

    const data = [];
    for (let [_a, state] of Object.entries(groupedByState)) {
      data.push({
        value: "not_allowed_custom",
        label: (
          <span
            style={{
              fontWeight: 600,
              fontSize: "1rem",
              color: "black",
              textTransform: "uppercase",
              padding: "5px 10px",
              borderBottom: "1px solid #ccc",
              backgroundColor: "#f8f8f8",
              display: "block",
              marginBottom: "5px",
            }}
          >
            {_a?.toUpperCase()}
          </span>
        ),
      });
      for (let value of state) {
        data.push({
          value: value._id,
          label: value.name,
        });
      }
    }
    return setManageList(data);
  };

  const fetchManagers = async (states, cities) => {
    if (
      stateRef?.current &&
      Array.isArray(stateRef.current) &&
      stateRef.current.length > 0 &&
      cityRef?.current &&
      Array.isArray(cityRef.current) &&
      cityRef.current.length > 0
    ) {
      const formattedStates = stateRef?.current?.map((state) => {
        return state.split("_")[1]?.replace(/\+/g, " ");
      });
      const filter = {
        states: formattedStates,
        cities: cityRef?.current,
      };

      try {
        const { status, data } = await Axios.get(API.MANAGER.STATES, {
          ...filter,
        });

        if (status) {
          setEmployees(data.data);
          handleManagerList(data.data);
        }
      } catch (error) {
        console.error("Error fetching managers:", error);
      }
    }
  };

  const updateCityList = () => {
    if (
      stateRef?.current &&
      Array.isArray(stateRef.current) &&
      stateRef.current.length > 0
    ) {
      const data = [];
      for (let val of stateRef.current) {
        let stateCode = val.split("_")[0];
        const cities = City.getCitiesOfState("IN", stateCode);
        data.push(...cities);
      }
      setCityOptions(data);
    }
  };

  const handleManagerChange = (event) => {
    const selectedValue = event.target.value;
    const selectedManagerObject = managers.find(
      (manager) => manager._id === selectedValue
    );
    setSelectedManager(selectedManagerObject);
  };

  const handleManagerChange1 = (event) => {
    const selectedManagerObject = event.target.value;
    console.log(event.target.value)
    setSelectedManager(selectedManagerObject);
  };

  const handlePermissionChange = (index, field, value) => {
    const updatedPermissions = [...permissions];
    updatedPermissions[index][field] = value;
    if (field === "all") {
      updatedPermissions[index].view = value;
      updatedPermissions[index].add = value;
      updatedPermissions[index].edit = value;
      updatedPermissions[index].delete = value;
    }
    setPermissions(updatedPermissions);
  };

  // Function to handle sub-admin details update
  const handleUpdateSubAdminDetails = async (formData) => {
    try {
      setVisible({ loader: true });
      const { state, city, stateCode, userList, ...rest } = formData;

      const addressObject = {};
      if (stateLabel) {
        addressObject.state = stateLabel;
      }
      if (statesCode) {
        addressObject.stateCode = statesCode;
      }
      if (city) {
        const selectedCity = newcityOptions.find((item) => item.label === city);
        addressObject.city = selectedCity ? selectedCity.label : city;
      }
      if (Object.keys(addressObject).length > 0) {
        addressObject.country = "India";
      }

      const params = {
        subAdminId: data._id,
        firstName: formData.firstName,
        lastName: formData.lastName,
        userName: data.userName,
        password: formData.password,
        isBlocked: isBlocked,
        roleId: data.roleId._id,
        permissions: data.roleId.permissions,
      };

      if (Object.keys(addressObject).length > 0) {
        params.address = addressObject;
      }

      if (selectedManager) {
        params.parentId =
          selectedManager && selectedManager._id
            ? selectedManager._id
            : selectedManager;
      }

      console.log("Updated sub-admin details:", params);
      const { status } = await Axios.patch(API.SUB_ADMIN.UPDATE, params);
      if (status) {
        // Update local state with new data
        setData((prev) => ({
          ...prev,
          ...params,
          address: addressObject,
          parentId: selectedManager,
        }));
        alert("Sub-admin details updated successfully!");
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible({ loader: false });
    }
  };

  // Function to handle permissions update
  const handleUpdatePermissions = async () => {
    try {
      setVisible({ loader: true });
      const params = {
        subAdminId: data._id,
        permissions: permissions,
      };

      console.log("Updated permissions:", params);
      const { status } = await Axios.patch(
        API.SUB_ADMIN.UPDATE,
        params
      );
      if (status) {
        alert("Permissions updated successfully!");
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible({ loader: false });
    }
  };

  // Function to handle block/unblock user
  const handleBlockUser = async () => {
    try {
      setVisible({ loader: true });
      const params = {
        subAdminId: data._id,
        isBlocked: !isBlocked,
      };

      console.log("Block user:", params);
      const { status } = await Axios.patch(API.SUB_ADMIN.UPDATE, params);
      if (status) {
        setIsBlocked(!isBlocked);
        setData(prev => ({...prev, isBlocked: !isBlocked}));
        alert(`User ${!isBlocked ? "blocked" : "unblocked"} successfully!`);
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible({ loader: false });
    }
  };

  useEffect(() => {
    if (subAdminId) {
      getData();
      getStates();
      getManagerData();
      getDataSure();

      // Initialize states list
      const statelist = State.getStatesOfCountry("IN");
      setStatesAndUTs(statelist);
    } else {
      navigate(EndPoints.SUB_ADMIN);
    }
  }, [subAdminId]);

  useEffect(() => {
    if (data.address && data.address.stateCode) {
      getCities(data.address.stateCode);
    }
  }, [data]);

  return (
    <>
      {visible.loader && <Loader />}
      <div className="profile-view">
        <div className="inner-agent">
          <h4>Sub-Admin Details</h4>

          <div className="d-flex justify-content-between align-items-center p-4">
            <div className="d-flex align-items-center">
              <span className="me-2">Edit</span>
              <Switch
                checked={isEditMode}
                onChange={() => setIsEditMode(!isEditMode)}
                inputProps={{ "aria-label": "Edit mode toggle" }}
              />
            </div>
            <div className="d-flex align-items-center">
              <span className="me-2">Block User</span>
              <Switch
                checked={isBlocked}
                onChange={handleBlockUser}
                inputProps={{ "aria-label": "Block user toggle" }}
              />
            </div>
          </div>

          <Formik
            initialValues={{
              firstName: data.firstName || "",
              lastName: data.lastName || "",
              userName: data.userName || "",
              password: data.dcryptedPass || "",
              state: data.address?.state || "",
              city: data.address?.city || "",
              manager: data.parentId || "",
            }}
            enableReinitialize={true}
            validationSchema={SuperAdminSchema}
            onSubmit={(values) => {
              handleUpdateSubAdminDetails(values);
            }}
          >
            {({ isSubmitting, errors, touched, setFieldValue, values }) => (
              <Form className="page-from">
                <div className="inner-form">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>First Name</label>
                      <Field
                        className="form-control"
                        type="text"
                        name="firstName"
                        disabled={!isEditMode}
                      />
                      {errors.firstName && touched.firstName ? (
                        <div className="error">{errors.firstName}</div>
                      ) : null}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Last Name</label>
                      <Field
                        className="form-control"
                        type="text"
                        name="lastName"
                        disabled={!isEditMode}
                      />
                      {errors.lastName && touched.lastName ? (
                        <div className="error">{errors.lastName}</div>
                      ) : null}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>UserId</label>
                      <Field
                        className="form-control"
                        type="text"
                        name="userName"
                        disabled={true}
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Password</label>
                      <Field
                        className="form-control"
                        type="text"
                        name="password"
                        disabled={!isEditMode}
                      />
                      {errors.password && touched.password ? (
                        <div className="error">{errors.password}</div>
                      ) : null}
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="state">State</label>
                      <Field
                        as="select"
                        className="form-control"
                        name="state"
                        value={statesCode}
                        disabled={!isEditMode}
                        onChange={(e) => {
                          const selectedStateCode = e.target.value;
                          const selectedState = statesAndNewUTs.find(
                            (item) => item.value === selectedStateCode
                          );

                          if (selectedState) {
                            setStateLabel(selectedState.label);
                            setStatesCode(selectedState.value);
                            getCities(selectedStateCode);
                          }
                        }}
                      >
                        <option
                          value={data.address?.stateCode || ""}
                          label={data.address?.state || "Select state"}
                        />
                        {statesAndNewUTs.map((state, index) => (
                          <option key={index} value={state.value}>
                            {state.label}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>City</label>
                      <Field
                        as="select"
                        name="city"
                        className="form-control"
                        disabled={!isEditMode}
                      >
                        <option
                          value={data.address?.city || ""}
                          label={data.address?.city || "Select a city"}
                        ></option>
                        {newcityOptions.map((city, index) => (
                          <option key={index} value={city.label}>
                            {city.label}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label htmlFor="manager">Reporting Manager</label>
                      {accountType !== 2 && accountType !== 3 ? (
                        <Field
                          as="select"
                          className="form-control"
                          name="manager"
                          disabled={!isEditMode}
                          onChange={handleManagerChange}
                          value={selectedManager?._id || ""}
                        >
                          <option value="" label="Select manager" />
                          {managers.map((manager) => (
                            <option key={manager._id} value={manager._id}>
                              {manager.name}
                            </option>
                          ))}
                        </Field>
                      ) : (
                        <Field
                          as="select"
                          className="form-control"
                          name="manager"
                          disabled={!isEditMode}
                          onChange={handleManagerChange1}
                          value={selectedManager?._id || ""}
                        >
                          <option value="" label="Select manager" />
                          {managers.length > 0 && (
                            <option key={managers[0]._id} value={managers[0]._id}>
                              {managers[0].name}
                            </option>
                          )}
                        </Field>
                      )}
                    </div>

                    {isEditMode && (
                      <>
                        <hr
                          style={{
                            backgroundColor: "white",
                            height: "6px",
                            width: "100%",
                          }}
                        />

                        <div className="col-md-12">
                          <h3 className="form-heading">Select Managers</h3>

                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <label htmlFor="secondstate">States</label>
                              <Field
                                name="secondstate"
                                options={statesAndUTs.map((state) => ({
                                  label: state.name,
                                  value: state.isoCode + "_" + state.name,
                                }))}
                                component={CustomSelect}
                                stateRef={stateRef}
                                placeholder="Select States"
                                isMulti={true}
                                isDisabled={!isEditMode}
                                onChange={(selectedStates) => {
                                  const statesArray = selectedStates.map(
                                    (state) => state.value
                                  );
                                  setFieldValue("state", statesArray);
                                  fetchManagers(statesArray, []);
                                }}
                              />
                            </div>

                            <div
                              className="col-md-4 mb-3"
                              onClick={updateCityList}
                            >
                              <label>City</label>
                              <Field
                                name="city2"
                                options={cityOptions.map((city) => ({
                                  label: city.name,
                                  value: city.name,
                                }))}
                                component={CustomSelect}
                                cityRef={cityRef}
                                placeholder="Select Cities"
                                isMulti={true}
                                isDisabled={!isEditMode}
                                onChange={(selectedCities) => {
                                  const citiesArray = selectedCities.map(
                                    (city) => city.value
                                  );
                                  setFieldValue("city", citiesArray);
                                  fetchManagers([], citiesArray);
                                }}
                              />
                            </div>

                            <div
                              className="col-md-4 mb-3"
                              onClick={fetchManagers}
                            >
                              <label htmlFor="userList">Select Managers</label>
                              <Field
                                name="userList"
                                options={manager}
                                component={CustomSelect}
                                placeholder="Select Managers..."
                                isMulti={true}
                                isDisabled={!isEditMode}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 mb-3">
                          <button
                            className="btn bg-gradient-dark mt-3 d-block btn-lg mb-1"
                            type="submit"
                          >
                            Update Sub-Admin Details
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>

          {/* Permissions Section with separate update button */}
          <div className="row mt-5">
            <div className="col-md-12">
              <table className="table table-bordered text-center">
                <thead className="bg-light text-dark">
                  <tr>
                    <th scope="col">Permissions</th>
                    <th scope="col">All</th>
                    <th scope="col">View</th>
                    <th scope="col">Add</th>
                    <th scope="col">Edit</th>
                    <th scope="col">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {permissions.map((access, index) => (
                    <tr key={index}>
                      <td>{access.name}</td>
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={access.all || false}
                          disabled={!isEditMode}
                          onChange={(e) =>
                            handlePermissionChange(
                              index,
                              "all",
                              e.target.checked
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={access.view || false}
                          disabled={!isEditMode}
                          onChange={(e) =>
                            handlePermissionChange(
                              index,
                              "view",
                              e.target.checked
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={access.add || false}
                          disabled={!isEditMode}
                          onChange={(e) =>
                            handlePermissionChange(
                              index,
                              "add",
                              e.target.checked
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={access.edit || false}
                          disabled={!isEditMode}
                          onChange={(e) =>
                            handlePermissionChange(
                              index,
                              "edit",
                              e.target.checked
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={access.delete || false}
                          disabled={!isEditMode}
                          onChange={(e) =>
                            handlePermissionChange(
                              index,
                              "delete",
                              e.target.checked
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {isEditMode && (
                <button
                  className="btn bg-gradient-primary mt-3 d-block btn-lg mb-1"
                  onClick={handleUpdatePermissions}
                >
                  Update Permissions
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubAdmin;